import { put, call } from 'redux-saga/effects';
import { certificatesList } from '../../../services/settings/affiliates/certificateService';

import * as types from '../../../actions';

export function* certificatesListSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(certificatesList, payload);
      yield put({ type: types.CERTIFICATES_LIST_SUCCESS, response })
      
    } catch(error) {
      yield put({ type: types.CERTIFICATES_LIST_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
    }
}

